/** Shared community feed empty-state copy (web + mobile). */

export const FEED_EMPTY_VERIFIED_ONLY =
  "No verified posts yet. Turn off Verified users to see more.";

export const FEED_EMPTY_VERIFIED_FILTERED =
  "No verified posts match your filters.";

export const FEED_EMPTY_FILTERED = "No posts match your filters.";

/**
 * Returns filter-specific empty message, or null when no feed filters apply.
 * @param {{ verifiedOnly: boolean, hasOtherFeedFilters: boolean }} params
 */
export function getFilteredFeedEmptyMessage({ verifiedOnly, hasOtherFeedFilters }) {
  if (verifiedOnly && !hasOtherFeedFilters) {
    return FEED_EMPTY_VERIFIED_ONLY;
  }
  if (verifiedOnly && hasOtherFeedFilters) {
    return FEED_EMPTY_VERIFIED_FILTERED;
  }
  if (hasOtherFeedFilters) {
    return FEED_EMPTY_FILTERED;
  }
  return null;
}
